import { uploadAttachments, saveAttachmentData, saveCommercialTerms, saveSpace, saveParkings, saveServiceCharge, deleteAttachment, submitProposal, saveFlexData, saveNumberOfOptions, saveFlexOptionData } from '../utils/api'
import { showLoading, hideLoading } from 'react-redux-loading'

export const RECEIVE_RFP_DATA = 'RECEIVE_RFP_DATA'
export const RECEIVE_OTHER_RFPS = 'RECEIVE_OTHER_RFPS'
export const UPDATE_ATTACHMENT = 'UPDATE_ATTACHMENT'
export const UPDATE_ATTACHMENTS = 'UPDATE_ATTACHMENTS'
export const UPDATE_COMMERCIAL_TERMS = 'UPDATE_COMMERCIAL_TERMS'
export const UPDATE_SPACE = 'UPDATE_SPACE'
export const UPDATE_PARKINGS = 'UPDATE_PARKINGS'
export const UPDATE_SERVICE_CHARGE = 'UPDATE_SERVICE_CHARGE'
export const SUBMIT_PROPOSAL = 'SUBMIT_PROPOSAL'
export const UPDATE_FLEX_DATA = 'UPDATE_FLEX_DATA'
export const UPDATE_NUMBER_OF_OPTIONS = 'UPDATE_NUMBER_OF_OPTIONS'

export function receiveRFPData (rfpData) {
	return {
		type: RECEIVE_RFP_DATA,
		rfpData
	}
}

export function receiveOtherRFPs (otherRFPs) {
	return {
		type: RECEIVE_OTHER_RFPS,
		otherRFPs
	}
}

export function handleUpdateAttachments (formData) {
	return (dispatch) => {
		dispatch(showLoading())

		return uploadAttachments(formData)
		.then((attachments) => {
			dispatch(updateAttachments(attachments))
		})
		.then(() => dispatch(hideLoading()))
	}
}

export function handleSaveAttachment (data) {
	return (dispatch) => {
		dispatch(showLoading())

		return saveAttachmentData(data)
		.then((attachments) => {
			dispatch(updateAttachments(attachments))
		})
		.then(() => dispatch(hideLoading()))
	}
}

export function handleDeleteAttachment (attachmentId) {
	return (dispatch) => {
		return deleteAttachment(attachmentId)
		.then((attachments) => {
			dispatch(updateAttachments(attachments))
		})
	}
}

export function handleSaveCommercialTerms (data) {
	return async dispatch => {
		dispatch(showLoading())
		const commercialTerms = await saveCommercialTerms(data);
		dispatch(updateCommercialTerms(commercialTerms))
		dispatch(hideLoading())
	}
}

export function handleSaveSpace (data) {
	return async dispatch => {
		dispatch(showLoading())
		const space = await saveSpace(data)
		dispatch(updateSpace(space))
		dispatch(hideLoading())
	}
}

export function handleSaveParkings (data) {
	return async dispatch => {
		dispatch(showLoading())
		const parkings = await saveParkings(data)
		dispatch(updateParkings(parkings))
		dispatch(hideLoading())
	}
}

export function handleSaveServiceCharge (data) {
	return async dispatch => {
		dispatch(showLoading())
		const serviceCharge = await saveServiceCharge(data)
		dispatch(updateServiceCharge(serviceCharge))
		dispatch(hideLoading())
	}
}

export function handleSubmitProposal (rfpId) {
	return (dispatch) => {
		return submitProposal(rfpId)
		.then(() => {
			dispatch(updateRFPStatus(3))
		})
	}
}

export function handleSaveFlexData (rfpId, data) {
	return (dispatch, getState) => {
		dispatch(showLoading())

		return saveFlexData(rfpId, data)
			.then((flexData) => {
				dispatch(updateFlexData(flexData))
				console.log('Received updated data', flexData)
			})
			.then(() => dispatch(hideLoading()))
	}
}

export function handleSaveNumberOfOptions (rfpId, numberOfOptions) {
	return (dispatch, getState) => {
		dispatch(showLoading())

		return saveNumberOfOptions(rfpId, numberOfOptions)
			.then((flexData) => {
				dispatch(updateFlexData(flexData))
				console.log('Received updated data', flexData)
			})
			.then(() => dispatch(hideLoading()))
	}
}

export function handleSaveFlexOptionData (rfpId, optionIndex, data) {
	return (dispatch, getState) => {
		dispatch(showLoading())

		return saveFlexOptionData(rfpId, optionIndex, data)
			.then((flexData) => {
				dispatch(updateFlexData(flexData))
			})
			.then(() => dispatch(hideLoading()))
	}
}

export function updateAttachment (data) {
	return {
		type: UPDATE_ATTACHMENT,
		data
	}
}

export function updateAttachments (attachments) {
	return {
		type: UPDATE_ATTACHMENTS,
		attachments
	}
}

export function updateCommercialTerms (commercialTerms) {
	return {
		type: UPDATE_COMMERCIAL_TERMS,
		commercialTerms
	}
}

export function updateSpace (space) {
	return {
		type: UPDATE_SPACE,
		space
	}
}

export function updateParkings (parkings) {
	return {
		type: UPDATE_PARKINGS,
		parkings
	}
}

export function updateServiceCharge (serviceCharge) {
	return {
		type: UPDATE_SERVICE_CHARGE,
		serviceCharge
	}
}

export function updateRFPStatus (statusId) {
	return {
		type: SUBMIT_PROPOSAL,
		statusId
	}
}

export function updateFlexData (flexData) {
	return {
		type: UPDATE_FLEX_DATA,
		flexData
	}
}

export function updateNumberOfOptions (numberOfOptions) {
	return {
		type: UPDATE_NUMBER_OF_OPTIONS,
		numberOfOptions
	}
}


// WEBPACK FOOTER //
// ./src/actions/rfp.js